// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-split-pane {
  --border: none;
  --side-min-width: 320px;
  --side-max-width: 320px;
}
ion-split-pane ion-menu {
  --max-width: auto;
  --width: 70%;
}
ion-split-pane ion-menu ion-header,
ion-split-pane ion-menu ion-content {
  --background: var(--ion-color-secondary);
  --ion-background-color: var(--ion-color-secondary);
  --ion-item-background: var(--ion-color-secondary);
  --ion-item-color: var(--ion-color-primary);
}
ion-split-pane ion-menu ion-header img.logo {
  height: 50px;
  margin-top: 8px;
}
ion-split-pane ion-menu ion-list {
  padding: 0 10px;
  background-color: var(--ion-color-primary);
}
ion-split-pane ion-menu ion-list ion-item-divider {
  min-height: auto;
  height: auto;
  border-color: var(--ion-color-primary-tint);
  margin-top: 20px;
}
ion-split-pane ion-menu ion-list ion-item {
  --ion-border-color: rgba(var(--ion-color-white-rgb), 0.2);
  --detail-icon-opacity: 1;
  margin-right: 16px;
}
ion-split-pane ion-menu ion-list ion-item ion-label {
  font-weight: bold;
  font-size: 0.8em;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,uBAAA;EACA,uBAAA;AACF;AAAE;EACE,iBAAA;EACA,YAAA;AAEJ;AADI;;EAEE,wCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;AAGN;AAAM;EACE,YAAA;EACA,eAAA;AAER;AACI;EACE,eAAA;EACA,0CAAA;AACN;AAAM;EACE,gBAAA;EACA,YAAA;EACA,2CAAA;EACA,gBAAA;AAER;AAAM;EACE,yDAAA;EACA,wBAAA;EACA,kBAAA;AAER;AADQ;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAGV","sourcesContent":["ion-split-pane {\r\n  --border: none;\r\n  --side-min-width: 320px;\r\n  --side-max-width: 320px;\r\n  ion-menu {\r\n    --max-width: auto;\r\n    --width: 70%;\r\n    ion-header,\r\n    ion-content {\r\n      --background: var(--ion-color-secondary);\r\n      --ion-background-color: var(--ion-color-secondary);\r\n      --ion-item-background: var(--ion-color-secondary);\r\n      --ion-item-color: var(--ion-color-primary);\r\n    }\r\n    ion-header {\r\n      img.logo {\r\n        height: 50px;\r\n        margin-top: 8px;\r\n      }\r\n    }\r\n    ion-list {\r\n      padding: 0 10px;\r\n      background-color: var(--ion-color-primary);\r\n      ion-item-divider {\r\n        min-height: auto;\r\n        height: auto;\r\n        border-color: var(--ion-color-primary-tint);\r\n        margin-top: 20px;\r\n      }\r\n      ion-item {\r\n        --ion-border-color: rgba(var(--ion-color-white-rgb), 0.2);\r\n        --detail-icon-opacity: 1;\r\n        margin-right: 16px;\r\n        ion-label {\r\n          font-weight: bold;\r\n          font-size: 0.8em;\r\n          text-transform: uppercase;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
